// CHA1-2308 (chargeback_back, see CREDIT_AUTOMATION_FRONTEND.md). `value` is the literal
// `failure_reason` / `action_needed_reason` string the API sends - not a slug, matched exactly.
// Shared between the admin "Change access request status" modal (the reason dropdown,
// CreditsAutomationPage/components/ChangeStatusModal) and the merchant-facing Credits page banner
// (the reason-specific "Action needed"/"Lost" copy, CreditsPage/components/Banner).
//
// Two reasons from the backend's dictionary are intentionally NOT here: "Waiting for the merchant
// to accept the request" pairs with a Pending row (not Action needed/Lost), and the Banner's
// Pending variant is a fixed generic message, not reason-driven - and "The access request has
// expired" is set by the system when a request times out, surfaced via `is_access_request_expired`
// rather than a dedicated banner reason for now.
export const ACTION_NEEDED_REASONS = [
  {
    value: "No invite arrived",
    label: "No invite received",
    bannerText:
      "We couldn't verify access to _name_: No invite received. Fix the issue and resubmit your request.",
    learnMoreUrl:
      "https://app.intercom.com/a/apps/i3j5um3v/knowledge-hub/all-content?activeContentId=20472348&activeContentType=article&editorMode=view&native_content=false"
  },
  {
    value: "The permission level is too low",
    label: "Limited permissions",
    bannerText:
      "We couldn't verify access to _name_: Limited permissions. Fix the issue and resubmit your request.",
    learnMoreUrl:
      "https://app.intercom.com/a/apps/i3j5um3v/knowledge-hub/all-content?activeContentId=20472945&activeContentType=article&editorMode=view&native_content=false"
  },
  {
    value: "The invite is for the wrong account",
    label: "Invite is for the wrong account",
    bannerText:
      "We couldn't verify access to _name_: Invite is for the wrong account. Fix the issue and resubmit your request.",
    learnMoreUrl:
      "https://app.intercom.com/a/apps/i3j5um3v/knowledge-hub/all-content?activeContentId=20472986&activeContentType=article&editorMode=view&native_content=false"
  },
  // The backend doc lists this as admin-settable, but section 6 ("what the backend does on its
  // own") says it's actually applied automatically when a new processor gets connected - kept
  // here anyway so the banner can look up its copy the same way as the other reasons.
  {
    value: "New connected integration",
    label: "A new integration was connected",
    bannerText:
      "We couldn't verify access to _name_: a new integration was connected. Submit a new request to add the new integration to Credit automation.",
    learnMoreUrl:
      "https://app.intercom.com/a/apps/i3j5um3v/knowledge-hub/all-content?activeContentId=20473016&activeContentType=article&editorMode=view&native_content=false"
  }
]

// Admin-selectable subset in the ChangeStatusModal dropdown - excludes "New connected
// integration", which per section 6 of the contract doc is applied by the system automatically,
// not chosen by an admin (despite section 2's classification table implying otherwise).
export const ADMIN_ACTION_NEEDED_REASON_OPTIONS = ACTION_NEEDED_REASONS.filter(
  (reason) => reason.value !== "New connected integration"
).map(({ value, label }) => ({ value, label }))
